import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../auth/guards/auth.guard';
import { RelatedContentGuard, RelatedEventsGuard, RelatedInitiativesGuard, RelatedStoriesGuard } from '../content/guards';
import { StoriesOverviewGuard } from '../stories/guards/stories.guard';
import { ThemesGuard } from '../themes/guards/themes.guard';
import { InitiativeDetailComponent } from './containers/initiative-detail/initiative-detail.component';
import { InitiativeFormComponent } from './containers/initiative-form/initiative-form.component';
import { InitiativesOverviewComponent } from './containers/initiatives-overview/initiatives-overview.component';
import { InitiativeDetailGuard } from './guards';
import { InitiativeDetailMetaGuard } from './guards/initiatives-detail-meta.guard';
import { InitiativesOverviewGuard } from './guards/initiatives.guard';

const routes: Routes = [
  {
    path: '',
    component: InitiativesOverviewComponent,
    pathMatch: 'full',
    canActivate: [InitiativesOverviewGuard, ThemesGuard],
    runGuardsAndResolvers: 'paramsOrQueryParamsChange',
  },
  {
    path: 'aanmelden',
    component: InitiativeFormComponent,
    canActivate: [ThemesGuard, AuthGuard],
  },
  {
    path: ':initiativeId/:title/bewerken',
    component: InitiativeFormComponent,
    canActivate: [InitiativeDetailGuard, ThemesGuard, AuthGuard],
  },
  {
    path: ':initiativeId/:title',
    component: InitiativeDetailComponent,
    canActivate: [
      InitiativeDetailGuard,
      InitiativeDetailMetaGuard,
      RelatedStoriesGuard,
      RelatedInitiativesGuard,
      RelatedEventsGuard,
      RelatedContentGuard,
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class InitiativesRoutingModule {}
